export function formatFloat(value) {
  return value ? value.toString().replace('.', ',') : null
}
